import * as yup from 'yup';
import { contactType, isAEPLat, isAEPLongi, pattern } from '../constant';

export const CNT_KEY = {
  PRJ_NM:'projectNm',
  CTYPE: 'contactType',
  FNAME: 'firstName',
  LNAME: 'lastName',
  CPNAME: 'companyName',
  EMAIL: 'email',
  MOBILE: 'mobileNo',
  CTNTNO: 'contactNo',
  ADD1: 'address1',
  ADD2: 'address2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zipCode',
  LAT: 'latitude',
  LONG: 'longitude',
  VALIDPOS:'isValidPos',
  HVCONN: 'haveConnection',
  CONTYPE: 'connectionType',
  CONID: 'connectionId',
  VALIDCON: 'isValidConnection',
  SAME_CD: 'sameAsprevious',
  VALIDZIP: 'isValidZip',
  DEROWNERFLAG:'derOwner',
  SECCUSTFLAG:'secCust',
  POIOWNERFLAG:'poiOwner',
  INSPELECFLAG:'insElect'
};
export const OTR_CNT_KEY = {
  FNAME: 'e_firstName',
  LNAME: 'e_lastName',
  CPNAME: 'e_companyName',
  EMAIL: 'e_email',
  MOBILE: 'e_mobileNo',
  CTNTNO: 'e_contactNo',
  ADD1: 'e_address1',
  ADD2: 'e_address2',
  CITY: 'e_city',
  STATE: 'e_state',
  ZIP: 'e_zipCode',
  VALIDZIP: 'e_isValidZip',

};

export const getInitialValues = (getAccount, getPosition, showOthers) => {
  return {
    ...(showOthers
      ? {
          [CNT_KEY.FNAME]: '',
          [CNT_KEY.LNAME]: '',
          [CNT_KEY.CPNAME]: '',
          [CNT_KEY.EMAIL]: '',
          [CNT_KEY.MOBILE]: '',
          [CNT_KEY.ADD1]: '',
          [CNT_KEY.ADD2]: '',
          [CNT_KEY.CITY]: '',
          [CNT_KEY.STATE]: '',
          [CNT_KEY.ZIP]: '',
          [CNT_KEY.VALIDZIP]: true,
        }
      : {}),
    ...(getAccount
      ? {
          [CNT_KEY.HVCONN]: 'yes',
          [CNT_KEY.CONID]: '',
          [CNT_KEY.VALIDCON]: true,
          [CNT_KEY.CONTYPE]: 'accNo',
        }
      : {}),
    ...(getPosition
      ? {
          [CNT_KEY.LAT]: '',
          [CNT_KEY.LONG]: '',
          [CNT_KEY.VALIDPOS]:true,
          [CNT_KEY.ADD1]: '',
          [CNT_KEY.ADD2]: '',
          [CNT_KEY.CITY]: '',
          [CNT_KEY.STATE]: '',
          [CNT_KEY.ZIP]: '',
          [CNT_KEY.VALIDZIP]: true,
        }
      : {}),
  };
};

export const getValidationSchema = (type) =>
  yup.object().shape({
    ...(type !== contactType.service
      ? getContactInfoObject(type)
      : getServiceInfoObject()),
  });

const getServiceInfoObject = () => ({
  [CNT_KEY.PRJ_NM]:yup.string().required('Required'),
  [CNT_KEY.CONID]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'yes',
    then: () =>
      yup
        .string()
        .required('Required')
        .test('lengthcheck', 'Enter valid digits', connectionIdCheck)
        .test('validcheck', 'Enter valid ID', function () {
          return this.parent[CNT_KEY.VALIDCON];
        }),
  }),
  [CNT_KEY.VALIDCON]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'yes',
    then: () =>
      yup
        .boolean()
        .test(
          'valid con check',
          'Please enter valid ID',
          (value) => value === true
        ),
  }),
  [CNT_KEY.LAT]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () =>
      yup
        .string()
        .required('Required')
        .matches(pattern.lat, 'Enter valid latitude')
        .test('lengthcheck', 'Enter valid latitude range', isAEPLat),
  }),
  [CNT_KEY.LONG]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () =>
      yup
        .string()
        .required('Required')
        .matches(pattern.longi, 'Enter valid longitude')
        .test('lengthcheck', 'Enter valid longitude range', isAEPLongi),
  }),
  [CNT_KEY.VALIDPOS]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () =>
      yup
        .boolean()
        .test(
          'valid con check',
          'Please enter valid position',
          (value) => value === true
        ),
  }),
  [CNT_KEY.ADD1]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () => yup.string().required('Required'),
  }),
  [CNT_KEY.CITY]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () => yup.string().required('Required'),
  }),
  [CNT_KEY.STATE]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () => yup.string().required('Required'),
  }),
  [CNT_KEY.ZIP]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () =>
      yup
        .string()
        .required('Required')
        .min(5, 'Zip must be 5 digits')
        .test('validcheck', 'Enter valid zip', function () {
          return this.parent[CNT_KEY.VALIDZIP];
        }),
  }),
  [CNT_KEY.VALIDZIP]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'no',
    then: () =>
      yup
        .boolean()
        .test(
          'valid con check',
          'Please enter valid ZIP',
          (value) => value === true
        ),
  }),
});

const getContactInfoObject = (type) => ({
  [CNT_KEY.CONID]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'yes',
    then: () =>
      yup
        .string()
        .required('Required')
        .test('lengthcheck', 'Enter valid digits', connectionIdCheck)
        .test('validcheck', 'Enter valid ID', function () {
          return this.parent[CNT_KEY.VALIDCON];
        }),
  }),
  [CNT_KEY.VALIDCON]: yup.string().when([CNT_KEY.HVCONN], {
    is: (value) => value === 'yes',
    then: () =>
      yup
        .boolean()
        .test(
          'valid con check',
          'Please enter valid ID',
          (value) => value === true
        ),
  }),

  ...(type === contactType.installer
    ? {
        [CNT_KEY.CPNAME]: yup.string().required('Required'),
      }
    : {}),

  //ADDRESS
  [CNT_KEY.ADD1]: yup.string().required('Required'),
  [CNT_KEY.CITY]: yup.string().required('Required'),
  [CNT_KEY.STATE]: yup.string().required('Required'),
  [CNT_KEY.ZIP]: yup
    .string()
    .required('Required')
    .min(5, 'Zip must be 5 digits')
    .test('validcheck', 'Enter valid zip', function () {
      return this.parent[CNT_KEY.VALIDZIP];
    }),

  [CNT_KEY.VALIDZIP]: yup
    .boolean()
    .test(
      'valid con check',
      'Please enter valid ZIP',
      (value) => value === true
    ),
  ...(type === contactType.customer
    ? {
        [CNT_KEY.LAT]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'no',
          then: () =>
            yup
              .string()
              .required('Required')
              .matches(pattern.lat, 'Enter valid latitude')
              .test('lengthcheck', 'Enter valid latitude range', isAEPLat),
        }),
        [CNT_KEY.LONG]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'no',
          then: () =>
            yup
              .string()
              .required('Required')
              .matches(pattern.longi, 'Enter valid longitude')
              .test('lengthcheck', 'Enter valid longitude range', isAEPLongi),
        }),
        [CNT_KEY.VALIDPOS]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'no',
          then: () =>
            yup
              .boolean()
              .test(
                'valid con check',
                'Please enter valid position',
                (value) => value === true
              ),
        }),
        [CNT_KEY.FNAME]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'yes',
          then: () => yup.string().required('Required'),
        }),
        [CNT_KEY.LNAME]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'yes',
          then: () => yup.string().required('Required'),
        }),
        [CNT_KEY.EMAIL]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'yes',
          then: () =>
            yup
              .string()
              .required('Required')
              .matches(pattern.email, 'Enter valid email id'),
        }),
        [CNT_KEY.MOBILE]: yup.string().when([CNT_KEY.HVCONN], {
          is: (value) => value === 'yes',
          then: () =>
            yup
              .string()
              .required('Required')
              .matches(pattern.phone, 'Enter valid phonenumber'),
        }),
      }
    : {
        [CNT_KEY.FNAME]: yup.string().required('Required'),
        [CNT_KEY.LNAME]: yup.string().required('Required'),
        [CNT_KEY.EMAIL]: yup
          .string()
          .required('Required')
          .matches(pattern.email, 'Enter valid email id'),
        [CNT_KEY.MOBILE]: yup
          .string()
          .required('Required')
          .matches(pattern.phone, 'Enter valid phonenumber'),
      })
});



export const getOtherContactInitailValues={
  [OTR_CNT_KEY.FNAME]: '',
  [OTR_CNT_KEY.LNAME]: '',
  [OTR_CNT_KEY.CPNAME]: '',
  [OTR_CNT_KEY.EMAIL]: '',
  [OTR_CNT_KEY.MOBILE]: '',
  [OTR_CNT_KEY.ADD1]: '',
  [OTR_CNT_KEY.ADD2]: '',
  [OTR_CNT_KEY.CITY]: '',
  [OTR_CNT_KEY.STATE]: '',
  [OTR_CNT_KEY.ZIP]: '',
  [OTR_CNT_KEY.VALIDZIP]: true,
}


export const getOtherContactScheme = (type) =>  yup.object().shape({
  //ADDRESS
  [OTR_CNT_KEY.ADD1]: yup.string().required('Required'),
  [OTR_CNT_KEY.CITY]: yup.string().required('Required'),
  [OTR_CNT_KEY.STATE]: yup.string().required('Required'),
  [OTR_CNT_KEY.ZIP]: yup
    .string()
    .required('Required')
    .min(5, 'Zip must be 5 digits')
    .test('validcheck', 'Enter valid zip', function () {
      return this.parent[OTR_CNT_KEY.VALIDZIP];
    }),

  [OTR_CNT_KEY.VALIDZIP]: yup
    .boolean()
    .test(
      'valid con check',
      'Please enter valid ZIP',
      (value) => value === true
    ),

        [OTR_CNT_KEY.FNAME]: yup.string().required('Required'),
        [OTR_CNT_KEY.LNAME]: yup.string().required('Required'),
        [OTR_CNT_KEY.EMAIL]: yup
          .string()
          .required('Required')
          .matches(pattern.email, 'Enter valid email id'),
        [OTR_CNT_KEY.MOBILE]: yup
          .string()
          .required('Required')
          .matches(pattern.phone, 'Enter valid phonenumber'),
});

function connectionIdCheck() {
  if (
    this.parent[CNT_KEY.CONTYPE] === 'accNo' &&
    this.parent[CNT_KEY.CONID].length === 10
  ) {
    return true;
  }
  if (
    this.parent[CNT_KEY.CONTYPE] === 'ezId' &&
    this.parent[CNT_KEY.CONID].length === 17
  ) {
    return true;
  }
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumberString;
}